import {
  TEAM_OVERVIEW_BOARD,
  TEAM_OVERVIEW_LAYOUT_VERSION,
  type TeamOverviewWidgetKey,
} from "@salestrak/widgets";
import { type ManagedWidget, withManagedLayoutVersion } from "./managed-widgets";

export { TEAM_OVERVIEW_LAYOUT_VERSION };

/**
 * Display copy for each Team Overview board entry — the board DATA lives in
 * @salestrak/widgets (shared with the core API's first-read
 * seeding). The `TeamOverviewWidgetKey` union makes a new board entry a
 * typecheck error until it gets copy.
 */
const PRESENTATION: Record<
  TeamOverviewWidgetKey,
  Pick<ManagedWidget, "label" | "description" | "color">
> = {
  "team-overview.active": {
    label: "Active projects",
    description: "A big-number count of active projects assigned to this team.",
  },
  "team-overview.members": {
    label: "Members",
    description: "Expandable member activity, workload, workflow, and project-type details.",
  },
  "team-overview.workload": {
    label: "Workload",
    description: "Project volume grouped by assignee, sorted by busiest first.",
  },
  "team-overview.activity": {
    label: "Recent activity",
    description: "The latest activity across this team's projects.",
  },
};

/**
 * The Team Overview managed widget catalog — the fixed, curated set the Team
 * Overview tab offers. Team Overview is NOT a free-form add-any-widget surface:
 * the user's only control is which of THESE widgets are visible (toggle on/off
 * via the Manage-widgets panel), and the designed positions ARE the layout
 * (the grid renders read-only).
 *
 * Because Team Overview is scoped by the ambient team `IssueScope`, every widget
 * is already narrowed to that team. This catalog persists on its own view via
 * `surfaceVariant="overview"`, using the same managed model as My Work.
 */
export const TEAM_OVERVIEW_WIDGETS: ManagedWidget[] = TEAM_OVERVIEW_BOARD.map((entry) => ({
  ...entry,
  config: withManagedLayoutVersion(TEAM_OVERVIEW_LAYOUT_VERSION, entry.config),
  ...PRESENTATION[entry.widgetKey],
}));
